module.exports = __webpack_public_path__ + "static/img/environment_05_h5.8c3709d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_05_h5.png
// module id = upS5
// module chunks = 34